module.exports = __webpack_public_path__ + "img/four-leaves.fdc5ed6a.svg";